import { HttpInterceptorFn } from '@angular/common/http';
import { inject, REQUEST_CONTEXT } from '@angular/core';
import { IServerRequestContext } from '../../models';
import { EnvironmentService } from '../../services';
import { isBackendUrl } from '../../utils/resolve-url.util';

export const basicInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentService = inject(EnvironmentService);
  // Context of the server render, null in the browser
  const requestContext = inject(REQUEST_CONTEXT, { optional: true }) as IServerRequestContext | null;

  const environmentHeader = environmentService.env.ENVIRONMENT
    ? {
        environment: environmentService.env.ENVIRONMENT,
      }
    : undefined;
  // The server render calls the backend for the visitor: with the secret the backend counts its session limit per IP against
  // this address. Only to the backend, the secret must not reach any other host.
  const clientAddressHeader =
    requestContext?.clientAddress && requestContext.ssrSecret && isBackendUrl(req.url, environmentService.env.BACKEND_URL)
      ? { 'X-Forwarded-For': requestContext.clientAddress, 'gs.ssr.secret': requestContext.ssrSecret }
      : undefined;

  req = req.clone({
    setHeaders: {
      ...environmentHeader,
      ...clientAddressHeader,
    },
  });

  return next(req);
};
